import { 
    UsersApi, 
    User, 
    CheckUserExistsDto, 
    UserExistsResponse,
    AddExistingUserDto,
    CreateNewUserDto 
} from "breuer-supercharged-sdk";
import { getClient } from "./client";

export class UsersService {
    private static instance: UsersService;

    private constructor() { }

    public static getInstance(): UsersService {
        if (!UsersService.instance) {
            UsersService.instance = new UsersService();
        }
        return UsersService.instance;
    }

    private client = new UsersApi(undefined, undefined, getClient())

    async findAllUsers(): Promise<User[]> {
        const response = await this.client.findAllUsers();
        return response.data;
    }

    async findOneUser(id: string): Promise<User> {
        const response = await this.client.findOneUser(id);
        return response.data;
    }

    async checkUserExists(checkUserExistsDto: CheckUserExistsDto): Promise<UserExistsResponse> {
        const response = await this.client.checkUserExists(checkUserExistsDto);
        return response.data;
    }

    async addExistingUserToTenant(addExistingUserDto: AddExistingUserDto): Promise<User> {
        const response = await this.client.addExistingUserToTenant(addExistingUserDto);
        return response.data;
    }

    async createNewUserAndAddToTenant(createNewUserDto: CreateNewUserDto): Promise<User> {
        const response = await this.client.createNewUserAndAddToTenant(createNewUserDto);
        return response.data;
    }

    async removeUserFromTenant(userId: string): Promise<void> {
        await this.client.removeUserFromTenant(userId);
    }

    async getCurrentUserProfile(): Promise<User> {
        const response = await this.client.getCurrentUserProfile();
        return response.data;
    }
}

// Keep the old class for backward compatibility
export class Users {
    private client = new UsersApi(undefined, undefined, getClient())

    public async getUsers() {
        const res = (await this.client.findAllUsers()).data;
        return res;
    }

    public async getUser(id: string) {
        const res = (await this.client.findOneUser(id)).data;
        return res;
    }
}